<template>
  <div
    :class="['relative flex h-full bg-base-0 editor-header',
             canUseNewCleanUpEditorUI? 'border-b border-gray-50' : 'shadow-top']"
  >
    <div class="editor-header-content">
      <div
        class="editor-header-left-side"
      >
        <EditorHeaderLogo />

        <!-- Edit name, private mode & sync loading -->
        <EditorHeaderPresentationName
          @updatePresentation="updatePresentation"
          :isSwitchingPresentationMode="isSwitchingPresentationMode"
        />

        <EditorHeaderPrivateModeSetting
          @switchPrivateMode="switchPrivateMode"
          :isSwitchingPresentationMode="isSwitchingPresentationMode"
        />

        <SyncLoading v-if="!isBackstage" />

        <div
          class="editor-header-line"
          v-if="!isBackstage"
          :class="{'hide-history-action': isEnableAddinPowerpoint && !isPPTEditMode}"
        >
          <svg
            width="3"
            height="29"
            viewBox="0 0 1 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.5"
              y1="2.18557e-08"
              x2="0.499999"
              y2="29"
              stroke="#D3D7E1"
            />
          </svg>
        </div>

        <ControlActionHistoriesV2
          v-if="canUseUndoRedoV2 && !isBackstage"
          :class="{'hide-history-action': isEnableAddinPowerpoint && !isPPTEditMode}"
        />
        <ControlActionHistories
          :class="{'hide-history-action': isEnableAddinPowerpoint && !isPPTEditMode}"
          v-else
        />

        <!-- In the future, the components in the header would be treated as 'plugins' -->
        <slot name="extension" />

        <div class="editor-header-right-side">
          <!-- <span
            class="actions-kebab-menu"
            @click="toggleSlideUp('actions')"
          >
            <aha-icon name="kebab-menu" />
          </span> -->

          <EditorHeaderMobileSlideUpMenu
            @switchPrivateMode="switchPrivateMode"
            @showSetting="showSetting()"
            @showDownload="openDownloadModal()"
            @showShare="showShare()"
            @showShareToEdit="isShareToEditDialogShowing = true"
          />

          <OnlineCollaboratorsList
            :list="presentationEditors"
            @openShareToEditPopup="handleShowShareV2"
            v-if="isOnlineCollabListVisible && !isBackstage && currentUser.id && !isEnableAddinPowerpoint"
          >
          </OnlineCollaboratorsList>

          <EditorHeaderShareButton
            class="share-v2"
            v-if="!isBackstage && !isEnableAddinPowerpoint"
            @showShare="showShare()"
          />

          <EditorHeaderToggleEdit v-if="isEnableAddinPowerpoint" />

          <div class="editor-header-line" v-if="isEnableAddinPowerpoint">
            <svg
              width="3"
              height="29"
              viewBox="0 0 1 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="0.5"
                y1="2.18557e-08"
                x2="0.499999"
                y2="29"
                stroke="#D3D7E1"
              />
            </svg>
          </div>

          <EditorHeaderShareButton
            class="share-v2"
            v-if="!isBackstage && isEnableAddinPowerpoint"
            @showShare="showShare()"
          />

          <EditorHeaderReportButtonPPT v-if="isEnableAddinPowerpoint" />

          <EditorHeaderButtonDownload
            v-if="!isEnableAddinPowerpoint"
            @showDownload="openDownloadModal"
            :isActive="isShowDownloadReport"
          />
          <EditorHeaderButtonsGroup
            v-if="!isBackstage && !isEnableAddinPowerpoint"
            @showSetting="showSetting()"
            @showExport="showExport()"
            :waitPresenting="waitPresenting"
            @togglePresentOptions="togglePresentOptions()"
            @startPresentingMode="startPresentingMode"
          />
          <EditorHeaderPresentButtonV2
            v-if="canUseRemoteControl"
            @togglePresentOptions="togglePresentOptions"
            @handlePresentMenuClick="handlePresentMenuClick"
            :showPresentOptions="showPresentOptions"
          />
          <EditorHeaderPresentButton
            v-else
            @togglePresentOptions="togglePresentOptions"
            @handlePresentMenuClick="handlePresentMenuClick"
            :showPresentOptions="showPresentOptions"
          />

          <EditorHeaderReportButton v-if="isParticipantReportButtonVisible" @showExport="showExport" />

          <!-- Present button mobile-->
          <!-- <span class="inline sm:hidden relative -top-0.5" v-if="!isEnableAddinPowerpoint">
            <aha-button
              class="min-w-0"
              :disabled="isNewPresentation || isDisableEditPresentation"
              @click="toggleSlideUp('present')"
              @mouseup.stop
            >
              <aha-icon
                name="play"
                viewBox="0 0 24 24"
                width="15"
                height="15"
                v-if="!waitPresenting"
              />
              <aha-spinner variant="white" v-else />
            </aha-button>
          </span> -->

          <!-- Slide Up for Present Button on mobile -->
          <EditorHeaderMobilePresentButton
            v-if="currentUser.rememberSettings"
            @handlePresentMenuClick="handlePresentMenuClick"
            @handleOpenBackstageWindow="_handleOpenBackstageWindow"
          />
        </div>

        <ModalConfirmPresentingNoLeaderboard
          v-if="isShowConfirmQuizPresentModal"
          @hideModal="isShowConfirmQuizPresentModal = false"
          @addQuiz="addQuiz()"
          @hideModalAndMaybePresent="hideModalAndMaybePresent(modalTypes.noLeaderBoard)"
        />

        <!-- Show when presenter click on Present but still in private mode -->
        <ModalEditorHeaderPrivateModeWarning
          v-if="isShowPrivateModeConfirmModal"
          @hideModal="isShowPrivateModeConfirmModal = false"
          :isShowCorrectAnswerReminder="_isShowCorrectAnswerReminder"
          :isAudiencePacing="_isAudiencePacing"
          @setScreenMode="_setScreenMode"
          @changeRouterIfPresenting="_changeRouterIfPresenting"
          @startPresenting="_startPresenting"
        />

        <EditorShareV2Modal
          :presentation="presentation"
          v-if="isShowShareV2Popup"
          @hideModal="hideModalShareV2"
        ></EditorShareV2Modal>

        <!-- Presenter click on Present but not check correct answer pick answer + pick img -->
        <ModalQuizNoCorrectAnswer
          type="quiz-no-correct-answer"
          :data="dataConfirm"
          @present="handleClickPresentAnyway(modalTypes.noCorrectAnswer)"
          @hide="hideModalAndMaybePresent(modalTypes.noCorrectAnswer)"
          v-if="isShowingModalQuizNoCorrectAnswer"
        />

        <ModalAudiencePacing
          @hide="hideModalAndMaybePresent(modalTypes.audiencePacing)"
          @present="handleClickPresentAnyway(modalTypes.audiencePacing)"
          v-if="isShowingModalAudiencePacing"
        />

        <ShareToEditModal
          v-if="isShareToEditDialogShowing && workingMode === 'personal'"
          :presentation="presentation"
          @hide="onHideShareToEditModal"
        />
        <ShareToTeamForEditModal
          :presentation="presentation"
          :teamName="currentAccount.name"
          v-if="isShareToEditDialogShowing && workingMode === 'team'"
          @hide="isShareToEditDialogShowing = false"
        />
        <InviteToTeamModal
          v-if="isInviteToTeamModalShowing"
          :presentation="presentation"
          :user="currentUser"
          :team="currentAccount"
          :toBeInvitedMembers="toBeInvitedMembers"
          @hide="onHideInviteToTeamModal"
        />
        <EditorDownloadReportModal
          v-if="isShowDownloadReport"
          @hide="isShowDownloadReport = false"
        />
        <WorkspaceReadyModal
          v-if="isWorkspaceReadyModalShowing"
          @hide="isWorkspaceReadyModalShowing = false"
        />
      </div>

      <div
        class="editor-header-tab-container"
        v-if="isShowResult"
      >
        <!-- Top header for mobile when open settings/share/results tab -->
        <div
          v-if="!isQuizTeamSetUpVisible || !isShowReport"
          class="sticky top-0 z-20 flex items-center justify-center h-16 font-bold
          shadow-top bg-base-0 text-base-90 md:hidden"
        >
          <span class="absolute cursor-pointer left-4 top-6" @click="handleBackDropClick">
            <aha-icon
              name="arrow-left"
              height="30"
              width="30"
              viewBox="0 0 30 30"
            />
          </span>

          <aha-icon
            :name="tabContent.icon"
            class="mr-2 text-base-70"
          />
          {{ tabContent.title }}
        </div>

        <!-- actual tab content section -->
        <Results
          v-if="isShowResult"
          @handle-hide-main-header="handleHideMainHeader()"
        />
      </div>

      <transition name="fade">
        <div
          @click="handleBackDropClick"
          class="fixed inset-0 z-10 hidden bg-base-100 opacity-20 md:block"
          v-if="isShowResult
            || showPresentOptions
          "
        />
      </transition>
    </div>
  </div>
</template>
<script>
import screenfull from 'screenfull'

// import { pages, app } from '@microsoft/teams-js'
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import Config from '@/config'
import Utils from '@/util'
import SurveyUtils from '@/utils/survey'
import EventBus from '@/eventBus'
import * as localStorageExpiry from '@/utils/local.storage.expiry'
import constants from '@/constant'
// api
import PresentationApi from '@/api/presentation'

import eventCategories from '@/constant/eventCategories'
import { SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE, WINDOWED_MODE } from '@/vuex/types'

import ShareToEditModal from '@/components-v2/modals/ShareToEditModal.vue'
import ShareToTeamForEditModal from '@/components-v2/modals/ShareToTeamForEdit.vue'
import Results from '@/components-v2/presentation-editor/editor-header/Results'
// import Share from '@/components-v2/presentation-editor/editor-header/Share.vue'
import OnlineCollaboratorsList from '@/components-v2/presentation-editor/editor-header/OnlineCollaboratorsList.vue'
import SyncLoading from '@/components-v2/presentation-editor/editor-header/SyncLoading'
import EditorHeaderLogo from '@/components-v2/presentation-editor/editor-header/EditorHeaderLogo.vue'
import EditorHeaderPresentationName from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentationName.vue'
import EditorHeaderShareButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderShareButton.vue'
// import EditorHeaderHelpCenter from '@/components-v2/presentation-editor/editor-header/EditorHeaderHelpCenter.vue'
import EditorHeaderButtonsGroup from '@/components-v2/presentation-editor/editor-header/EditorHeaderButtonsGroup.vue'
import EditorHeaderPresentButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton.vue'
import EditorHeaderPresentButtonV2 from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButtonV2.vue'
import EditorHeaderReportButton from '@/components-v2/presentation-report/EditorHeaderReportButton.vue'
import EditorHeaderMobilePresentButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderMobilePresentButton.vue'
import EditorHeaderMobileSlideUpMenu from '@/components-v2/presentation-editor/editor-header/EditorHeaderMobileSlideUpMenu.vue'
import EditorHeaderPrivateModeSetting from '@/components-v2/presentation-editor/editor-header/EditorHeaderPrivateModeSetting.vue'
// import EditorHeaderHomeButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderHomeButton.vue'
import ModalEditorHeaderPrivateModeWarning from '@/components-v2/modals/EditorHeaderPrivateModeWarning.vue'
import ModalConfirmPresentingNoLeaderboard from '@/components-v2/modals/EditorHeaderPresentingNoLeaderboard.vue'
import EditorShareV2Modal from '@/components-v2/modals/EditorShareV2Modal.vue'
import InviteToTeamModal from '@/components-v2/modals/InviteToTeamModal.vue'
import WorkspaceReadyModal from '@/components-v2/modals/WorkspaceReadyModal.vue'

import ModalQuizNoCorrectAnswer from '../../modals/QuizNoCorrectAnswer.vue'
import ModalAudiencePacing from '../../modals/AudiencePacing.vue'
import ControlActionHistories from '@/components-v2/presentation-editor/editor-header/ControlActionHistories'
import ControlActionHistoriesV2 from '@/components-v2/presentation-editor/editor-header/ControlActionHistories.v2'
import PresentationMixpanelTracker from '@/utils/mixpanel/presentation.mixpanel-tracker'
import EditorHeaderButtonDownload from '@/components-v2/presentation-editor/editor-header/EditorHeaderButtonDownload.vue'
import EditorDownloadReportModal from '@/components-v2/presentation-editor/editor-header/EditorDownloadReportModal.vue'

import EditorHeaderToggleEdit from '@/components-v2/presentation-editor/editor-header/EditorHeaderToggleEdit.vue'
import EditorHeaderReportButtonPPT from '@/components-v2/presentation-report/EditorHeaderReportButtonPPT.vue'

import SystemConnection, { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

const modalTypes = {
  noLeaderBoard: 1,
  privateMode: 2,
  noCorrectAnswer: 3,
  audiencePacing: 4,
}

const PRESENT_BACKSTAGE_EVENT = 'present-with-backstage'
const OPEN_REMOTE_CONTROL_EVENT = 'open-remote-control'
const WINDOW_WIDTH_OFFSET = 240
const WINDOW_HEIGHT_OFFSET = 180

export default {
  components: {
    ModalQuizNoCorrectAnswer,
    ModalAudiencePacing,
    ControlActionHistoriesV2,
    // Share,
    Results,
    OnlineCollaboratorsList,
    SyncLoading,
    ControlActionHistories,
    EditorHeaderLogo,
    EditorHeaderPresentationName,
    EditorHeaderShareButton,
    EditorHeaderButtonDownload,
    EditorDownloadReportModal,
    // EditorHeaderHelpCenter,
    EditorHeaderButtonsGroup,
    EditorHeaderPresentButton,
    EditorHeaderReportButton,
    EditorHeaderMobilePresentButton,
    EditorHeaderPresentButtonV2,
    EditorHeaderMobileSlideUpMenu,
    EditorHeaderPrivateModeSetting,
    EditorShareV2Modal,
    ModalEditorHeaderPrivateModeWarning,
    ModalConfirmPresentingNoLeaderboard,
    // EditorHeaderHomeButton,
    ShareToEditModal,
    ShareToTeamForEditModal,
    InviteToTeamModal,
    WorkspaceReadyModal,
    EditorHeaderToggleEdit,
    EditorHeaderReportButtonPPT,
  },
  data() {
    return {
      waitPresenting: false,
      isSwitchingPresentationMode: false,
      isShowPrivateModeConfirmModal: false,
      isShowConfirmQuizPresentModal: false,
      isShowingModalQuizNoCorrectAnswer: false,
      isShowingModalAudiencePacing: false,
      isShareToEditDialogShowing: false,
      isShowReport: false,
      isShowDownloadReport: false,
      showPresentOptions: false,
      isSlideUpVisible: false,
      isSlideUpPresentVisible: false,
      dataConfirm: {},
      defaultExpandedAccordion: '',
      defaultExpandedAccordionShare: '',
      modalTypes,
      isShowShareACopyList: false,
      backStageWindow: null,
      // onlineCollaboratorsList: fixtures.onlineCollaboratorsList,
      clickedOnPresentWithBackstage: false,
      isInviteToTeamModalShowing: false,
      isWorkspaceReadyModalShowing: false,
      toBeInvitedMembers: null,
      isEnableAddinPowerpoint: Config.isEnableAddinPowerpoint,
    }
  },

  computed: {
    constants() {
      return constants
    },
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapGetters('featureToggles', ['canUseNewCleanUpEditorUI']),
    ...mapGetters('rightPanelContainer', ['isQuizTeamSetUpVisible']),
    ...mapGetters('leaderboard', ['canUseLeaderboardToggleOnPresenting']),
    ...mapGetters('history', ['canUseUndoRedoV2']),
    ...mapGetters('remoteControlLink', ['canUseRemoteControl', 'remoteLink']),
    ...mapState({
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      isNewPresentation: (state) => state.isNewPresentation,
      isGuestUser: (state) => state.currentUser.isGuest,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
      presentationEditors: (state) => state.presentationEditors,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      slideActive: (state) => state.slideActive,
      workingMode: (state) => state.workingMode,
      isPPTEditMode: (state) => state.isPPTEditMode,
      powerPointSlideId: (state) => state.powerPointSlideId,
      activePresentationPowerpointId: (state) => state.activePresentationPowerpointId,
    }),

    isShowShareV2Popup() {
      return this.presentation.id &&
          this.presentation.showShare
    },
    isShowResult() {
      return this.presentation.id && this.presentation.showExport
    },
    tabContent() {
      const contentMap = {}
      if (this.isShowResult) {
        contentMap.title = 'Results'
        contentMap.icon = 'download'
      }
      return contentMap
    },
    hasNoCode() {
      return !this.presentation.qrcode
        || !this.presentation.shareCode
        || !this.presentation.uniqueAccessCode
    },
    isOnlineCollabListVisible() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },
    qrCodeKey() {
      return `closeAutoOpenQRCode-prez${this.presentation.id}`
    },
    hasTeam() {
      return this.currentAccount.id
    },
    isTeamOwner() {
      return this.currentUser.accountRole === 'owner'
    },
    isParticipantReportButtonVisible() {
      return !this.isEnableAddinPowerpoint && !this.isBackstage
    },
  },
  mounted() {
    const { presenting, openRequestPresentation } = this.$route.query
    EventBus.$on('show-setting-popup', ({ defaultExpandedAccordion }) => {
      this.showSetting({ defaultExpandedAccordion })
    })
    EventBus.$on('open-backstage-window', this._handleOpenBackstageWindow)
    EventBus.$on('close-backstage-window', this.closeBackstageWindow)
    EventBus.$on(PRESENT_BACKSTAGE_EVENT, () => {
      this.handlePresentMenuClick(PRESENT_BACKSTAGE_EVENT)
    })
    EventBus.$on(OPEN_REMOTE_CONTROL_EVENT, () => {
      this._openRemoteControl()
    })
    EventBus.$on('EditorHeader: toggle-team-setup', () => {
      this.handleHideMainHeader()
    })

    if (presenting && !this.sharePresentation && !this.isEnableAddinPowerpoint) {
      this._setScreenMode()
    }

    if (this.sharePresentation) {
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
      window.dispatchEvent(new Event('resize'))
    }
    this.handleTriggerOpenReport()
    this.handleTriggerFromQueryParams()
    window.addEventListener('unload', () => {
      if (this.isBackstage && localStorage) {
        localStorage.removeItem(`Backstage_${this.presentation.id}`)
      }
    })
    if (openRequestPresentation) {
      this.showShare()
      this.defaultExpandedAccordionShare = 'shareToCopy'
      this.$router.replace({ query: {} })
    }
    EventBus.$on('start-presenting-now', () => {
      this.startPresentingMode(true)
    })

    this.handleShowShareToEdit()

    if (presenting && this.isEnableAddinPowerpoint) {
      this.handlePresentingForPPTAddin()
    }
  },
  destroyed() {
    EventBus.$off('show-setting-popup')
    EventBus.$off('open-backstage-window')
    EventBus.$off('close-backstage-window')
    EventBus.$off(PRESENT_BACKSTAGE_EVENT)
    EventBus.$off('start-presenting-now')
    EventBus.$off('EditorHeader: toggle-team-setup')
    EventBus.$off(OPEN_REMOTE_CONTROL_EVENT)
  },
  methods: {
    ...mapActions([
      'patchPresentationAction',
      'updateSlideActiveAction',
      'setSlideActiveAction',
      'setSyncLoadingAction',
      'getCurrentUserAction',
      'setCurrentAccountAction',
      'toggleQRCodePanelAction',
      'updatePresentationAction',
    ]),
    ...mapActions('rightPanelContainer', ['toggleQuizTeamSetUpVisibleAction']),
    handleShowShareToEdit() {
      const inviteToEdit = Utils.getParamValue('inviteToEdit')
      const email = Utils.getParamValue('email')

      if (inviteToEdit) {
        this.updatePresentationAction({
          defaultTabShare: 'addEditor',
        })
        this.showShare()
        const query = {}
        if (email) {
          query.email = email
        }
        this.$router.replace({ query })
      }
    },
    hasClosedQRCode() {
      return localStorageExpiry.getWithExpiry(this.qrCodeKey)
    },
    handleTriggerOpenReport() {
      const reportQueryParam = Utils.getParamValue('report')
      if (reportQueryParam) {
        // Esc presenting mode to view the report
        this.$store.dispatch('setCurrentSlideMode', 'editMode')
        this.showExport()
      }
    },
    handleTriggerFromQueryParams() {
      const shouldOpenExport = Utils.getParamValue('export')
      if (shouldOpenExport) {
        this.showExport()
      }
    },
    handleHideMainHeader() {
      this.toggleQuizTeamSetUpVisibleAction()
      this.isShowShareACopyList = !this.isShowShareACopyList
      this.isShowReport = !this.isShowReport
    },

    togglePresentOptions() {
      if (this.isNewPresentation && !this.canEditPresentation) {
        return
      }
      this.showPresentOptions = !this.showPresentOptions
    },

    trackStartPresenting(eventLabel) {
      const presentationTracker = new PresentationMixpanelTracker(this.presentation, this.$route.name, this.currentUser)
      presentationTracker.trackStartPresenting(eventLabel, this.presentation.id)
    },

    // handle close context-menu and slide-up when clicking the item inside
    handlePresentMenuClick(type, isSlideup) {
      if (type === 'present-now') {
        this.startPresentingMode(true)
        this.trackStartPresenting('Present Dropdown Menu > Present now')
      }
      if (type === 'present-from-beginning') {
        this.startPresentingMode(true, true)
        this.trackStartPresenting('Present Dropdown Menu > Present from beginning')
      }
      if (type === PRESENT_BACKSTAGE_EVENT) {
        this.clickedOnPresentWithBackstage = true
        this.startPresentingMode(true, false, PRESENT_BACKSTAGE_EVENT)
        this.trackStartPresenting('Present Dropdown Menu > Present with Backstage')
      }
      if (isSlideup) {
        this.toggleSlideUp('present')
      } else {
        this.togglePresentOptions()
      }
      this.showPresentOptions = false
    },

    toggleSlideUp(type) {
      if (type === 'actions') {
        EventBus.$emit('show-mobile-slide-up-menu')
      }
      if (type === 'present') {
        EventBus.$emit('show-mobile-present-btn')
      }
    },
    openDownloadModal() {
      this.isShowDownloadReport = true
    },

    handleBackDropClick() {
      const isQueryReport = Utils.getParamValue('report')
      if (isQueryReport) {
        this.$router.replace({ query: {} })
      }
      this.$store.state.presentation.showSetting = false
      this.$store.state.presentation.showShare = false
      this.$store.state.presentation.showExport = false
      this.isShowShareACopyList = false
      this.showPresentOptions = false
    },

    _setScrollClass(settingOn) {
      if (settingOn) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    },

    showSetting(config) {
      if (config) {
        this.defaultExpandedAccordion = config.defaultExpandedAccordion || ''
      }
      this.patchPresentationAction({
        showSetting: true,
        showExport: false,
        showShare: false,
      })
      this._setScrollClass(this.presentation.showSetting)

      if (this.$store.state.presentation.showSetting) {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Open settings menu')
      } else {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Close settings menu')
      }
    },
    hideModalShareV2({ toBeInvitedMembers }) {
      this.patchPresentationAction({
        showShare: false,
      })
      this.checkToShowInviteTeamModal(toBeInvitedMembers)
    },
    trackingOpenTabShare() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Open Share menu', null, null, {
        presentationId: this.presentation.id,
        userId: this.currentUser.id,
        isPresentationOwner: this.presentation.userId === this.currentUser.id,
      })
    },
    async showShare() {
      this.patchPresentationAction({
        showShare: true,
        showSetting: false,
        showExport: false,
      })
      this._setScrollClass(this.presentation.showShare)
      if (this.presentation.showShare) {
        this.trackingOpenTabShare()
      } else {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Close invite menu')
      }

      if (this.hasNoCode) {
        try {
          const res = await PresentationApi.getPresentationBasic(this.presentation.id)
          this.patchPresentationAction({
            qrcode: res.qrcode,
            shareCode: res.shareCode,
            uniqueAccessCode: res.uniqueAccessCode,
          })
        } catch (error) {
          Sentry.captureException(error, 'getPresentationBasic failed.')
        }
      }
    },
    showExport() {
      this.$router.push({
        name: 'PresentationReport',
        params: { id: this.presentation.id },
      })
      this.isShowReport = true
      Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_EDITOR, {
        eventAction: 'Editor Header > Open results',
        eventCategory: eventCategories.PRESENTATION_EDITOR,
        ...{
          presentationId: this.presentation.id,
        },
      })
    },

    async updatePresentation(payload) {
      this.$store.dispatch('setSyncPresentation', 1)
      let res

      try {
        res = await this.$http.put(Config.api.updatePresentation + this.$route.params.id, payload)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw error
      }

      if (payload.name) {
        const [, changedRow] = res.body
        const { name, slugifiedName } = changedRow[0]
        this.patchPresentationAction({
          name,
          slugifiedName,
        })
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Editor Header > Presentation Name > Submit',
        )
      }

      this.$store.dispatch('setSyncPresentation', 2)
    },

    async switchPrivateMode() {
      // if (this.isDisableEditPresentation) return
      this.isSwitchingPresentationMode = true
      const presentationId = this.$route.params.id
      const payload = { privateMode: !this.$store.state.presentation.privateMode }

      try {
        await this.$http.put(Config.api.updatePresentation + presentationId, payload)
      } catch (error) {
        Utils.showToastError(this.$i18nPresenter.t('Changing status failed. Please try again.'))
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Private mode setting > Presenter changed Private Mode failed', JSON.stringify(error))
        throw error
      } finally {
        this.isSwitchingPresentationMode = false
      }

      this.$store.state.presentation.privateMode = payload.privateMode
      Utils.showToastSuccess(`${this.$i18nPresenter.t('Presentation has been switched to')} ${this._setPrivateModeStatus()}.`)
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Private mode setting > Success', `Switch to ${this._setPrivateModeStatus()}`)
    },

    _setPrivateModeStatus() {
      if (this.$store.state.presentation.privateMode) {
        return 'private'
      }
      return 'public'
    },

    waitingTakeOver() {
      return new Promise((resolve) => {
        EventBus.$emit('take-over-event', () => {
          resolve()
        })
      })
    },

    async startPresentingMode(isExtraButton, isBeginning, presentingType) {
      if (this.isNewPresentation) {
        return
      }
      this.$store.state.presentIsBeginning = isBeginning
      this.$store.state.presentIsExtraButton = isExtraButton
      // if (this.presentation.takenOverBy !== this.currentUser.id) {
      //   await this.waitingTakeOver()
      // }
      if (this.checkLeaderboard()) {
        this.isShowConfirmQuizPresentModal = true
        return
      }
      if (this._checkShowPrivateModeModal()) return
      if (this._isShowCorrectAnswerReminder()) return
      if (this._isAudiencePacing()) return
      if (presentingType === PRESENT_BACKSTAGE_EVENT) {
        this._handleOpenBackstageWindow()
      }
      this._startPresenting()
      this.showPresentOptions = false
      localStorage.removeItem('list_showed_result_id')
      localStorage.removeItem('isUserClosePopupForFreePlan')
    },

    hasBackstageWindow() {
      return this.backStageWindow && JSON.parse(localStorage.getItem(`Backstage_${this.presentation.id}`) || false)
    },

    _isAudiencePacing() {
      if (this.$store.state.presentation.audiencePacing) {
        this.isShowingModalAudiencePacing = true
        return true
      }
      return false
    },

    _checkShowPrivateModeModal() {
      if (this.$store.state.presentation.privateMode) {
        this.isShowPrivateModeConfirmModal = true
        return true
      }
      return false
    },

    _isShowCorrectAnswerReminder() {
      if (this.slideActive.slideType === 'matchPairs') return false
      if (this.slideActive.slideType === 'categorise') return false

      const numberOfSlideNotCheck = this.presentation.quizNoCorrectAnswer.length
      if ((numberOfSlideNotCheck > 0 && this.presentation.notRemindCorrectAnswer)
       || numberOfSlideNotCheck === 0) {
        return false
      }
      this._sendDataConfirmToReminderModal()
      return true
    },

    _removeNoIDSlidesAndSetSlideActive() {
      const hasSlides = this.presentation && this.presentation.slides && this.presentation.slides.length
      if (!hasSlides) return
      const slidesToPresent = this.presentation.slides.filter((s) => s.id)
      const activeSlide = this._getSlideActiveForPresenting()
      this.patchPresentationAction({
        slides: slidesToPresent,
      })
      this.setSlideActiveAction(activeSlide)
    },

    _getSlideActiveForPresenting() {
      if (this.slideActive.id) return this.slideActive
      const activeIndex = this.presentation.slides.findIndex((s) => s.order === this.slideActive.order)
      let activeSlide = this.presentation.slides[0]
      if (activeIndex < 0) return activeSlide
      if (activeIndex === 0) { // is first slide -> active next slide
        activeSlide = this.presentation.slides[activeIndex + 1]
      } else if (activeIndex >= 1) { // is not first slide -> active prev slide (same behavior as delete empty slide)
        activeSlide = this.presentation.slides[activeIndex - 1]
      }
      return activeSlide
    },

    _startPresenting() {
      if (this.clickedOnPresentWithBackstage) {
        this._handleOpenBackstageWindow()
      }
      this.waitPresenting = true
      this.updateSlideActiveAction({
        showFullImageQuestion: false,
      })
      this.updatePresentationByType('startPresenting')
      sessionStorage.removeItem(`expanded-feedback-panel-${this.presentation.id}`)
      this.$store.commit('setStartPresentingFromSlideId', this.slideActive.id)
    },

    updatePresentationByType(type) {
      if (this.$store.state.presentIsBeginning) {
        const firstSlide = this.presentation.slides[0]
        if (firstSlide.id) {
          this.updateSlideActiveAction({
            id: null,
          })
          this.setSlideActiveAction(firstSlide)
          EventBus.$emit('eventHandleSetValueTransition')
          EventBus.$emit('updateNextSlide', firstSlide.id)
        }
      }

      let payload = {}

      if (type === 'startPresenting') {
        payload = {
          presenting: true,
          activeSlidePreseting: this.$store.state.slideActive.id,
          activeSlideAccessCode: this.$store.state.presentation.uniqueAccessCode,
        }
      } else if (type === 'notRemindCorrectAnswer') {
        payload = {
          notRemindCorrectAnswer: this.$store.state.presentation.notRemindCorrectAnswer,
        }
      }
      this._updatePresentationByType(type, payload)
    },

    async _updatePresentationByType(type, payload) {
      try {
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
        SystemConnection.detectGeneralConnection(CONNECTION_STATUS.GOOD)
        if (this.presentation.takenOverBy !== this.currentUser.id) {
          await this.waitingTakeOver()
        }
        if (type === 'startPresenting') {
          this._handleAfterUpdatePresentationByType()
        }
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncLoadingAction(3)
      }
    },

    _handleAfterUpdatePresentationByType() {
      this.waitPresenting = false
      this.$store.state.showLiveAudienceDemo = false

      // AHA-890 Remember fullscreen setting
      if (this.$store.state.presentIsExtraButton) {
        if (this.$store.state.presentIsBeginning) {
          Utils.mixpanelTracking(
            eventCategories.PRESENTATION_EDITOR,
            'Editor Header > Extra Present button > Present from beginning',
            `Presentation: ${this.presentation.id}`,
          )
        } else {
          Utils.mixpanelTracking(
            eventCategories.PRESENTATION_EDITOR,
            'Editor Header > Extra Present button > Present now',
            `Presentation: ${this.presentation.id}`,
          )
        }
      } else {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Editor Header > Main Present button',
          `Presentation: ${this.presentation.id}`,
        )
      }
      if (!this.hasClosedQRCode()) {
        setTimeout(() => {
          this.toggleQRCodePanelAction(true)
          Utils.mixpanelTracking(eventCategories.PRESENTING_MODE, 'QR code auto enable', 'Open QR code', this.slideActive.id, {
            slideIndex: this.slideActive.index,
          })
        }, 1000)
      }
      this._setScreenMode()
      this._changeRouterIfPresenting()
      this._removeNoIDSlidesAndSetSlideActive()
      this.updateOnlineCount()
      if (this.slideActive.type === 'pickAnswer') {
        this._getAudienceOnlineForQuiz()
      }
      SurveyUtils.addStyleDisplayNoneToSurvey() // to prevent survey showing in editor still shows in presenting
    },

    updateOnlineCount() {
      const userOnlineCount = this.$store.state.userOnline
      setTimeout(() => {
        this.$emit('update-online-count', this.presentation.id, userOnlineCount)
      }, 10000)
    },

    _getAudienceOnlineForQuiz() {
      PresentationApi.getAudienceOnline({
        accessCode: this.presentation.uniqueAccessCode,
      })
    },

    async _setScreenMode() {
      if (this.clickedOnPresentWithBackstage) {
        this._handleOpenBackstageWindow()
      }
      // AHA-890 Remember fullscreen setting
      if (this.$store.state.currentUser.rememberSettings
            && this.$store.state.currentUser.rememberSettings.fullscreen
            && !this.$store.state.isPlayDemoMode) {
        try {
          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)
          screenfull.request().catch(() => {})
        } catch (error) {
          Sentry.captureException(error)
          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
          window.dispatchEvent(new Event('resize'))
        }
      } else {
        this.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
        window.dispatchEvent(new Event('resize'))
      }
    },

    _changeRouterIfPresenting() {
      if (window.innerWidth > 800) {
        this.$router.replace({
          name: 'PresentationDetail',
          params: { id: this.$store.state.presentation.id },
          query: { presenting: true },
        })
      }
    },

    checkLeaderboard() {
      if (this.canUseLeaderboardToggleOnPresenting) {
        return false
      }
      const { slides } = this.$store.state.presentation
      let indexQuiz = 0
      const slidesQuiz = slides.filter((item) => {
        return item.type === 'pickAnswer'
      })
      const slidesLeaderboard = slides.filter((item) => {
        return item.type === 'leaderboard'
      })
      if (slidesQuiz.length) {
        indexQuiz = Utils.getIndexSlide(
          slides,
          slidesQuiz[slidesQuiz.length - 1].id,
        )
      } else {
        return false
      }

      if (!slidesLeaderboard.length) {
        return true
      }

      const index = Utils.getIndexSlide(
        slides,
        slidesLeaderboard[slidesLeaderboard.length - 1].id,
      )

      if (index > indexQuiz) {
        return false
      }
      return true
    },

    hideModalAndMaybePresent(type) {
      if (type === modalTypes.noLeaderBoard) {
        this.isShowConfirmQuizPresentModal = false
        if (this._checkShowPrivateModeModal()) return
        if (this._isShowCorrectAnswerReminder()) return
        if (this._isAudiencePacing()) return
      } else if (type === modalTypes.noCorrectAnswer) {
        this.$store.state.presentation.notRemindCorrectAnswer = false
        this.isShowingModalQuizNoCorrectAnswer = false
        return
      } else if (type === modalTypes.audiencePacing) {
        this.isShowingModalAudiencePacing = false
        return
      }
      this._startPresenting()
    },
    addQuiz() {
      this.isShowConfirmQuizPresentModal = false
      EventBus.$emit('addSlideLeaderboard', {
        lastSlide: true,
      })
      if (this._checkShowPrivateModeModal()) return
      this._isShowCorrectAnswerReminder()
    },

    _sendDataConfirmToReminderModal() {
      this._setIndexSlide()
      this._setContentForReminderModal()
      this._trackGAForReminderModal()
      this.isShowingModalQuizNoCorrectAnswer = true
    },

    _setIndexSlide() {
      this.presentation.quizNoCorrectAnswer.forEach((slide) => {
        slide.index = Utils.getIndexSlide(this.$store.state.presentation.slides, slide.id) + 1
      })
    },

    _setContentForReminderModal() {
      if (this.presentation.quizNoCorrectAnswer.length === 1) {
        this.dataConfirm = {
          title: this.$i18nPresenter.t('Quiz slide having no correct answers?'),
          description: this.$i18nPresenter.t("You haven't specified the correct answer for this Quiz question:"),
        }
      } else {
        this.dataConfirm = {
          title: this.$i18nPresenter.t('Quiz slides having no correct answers?'),
          description: this.$i18nPresenter.t('youHaventSpecifiedCorrectAnswerForXQuizQuestion', {
            length: this.presentation.quizNoCorrectAnswer.length,
          }),
        }
      }
    },

    _trackGAForReminderModal() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Present Button > Modal unchecked correct answer reminder pops up', `Presentation id: ${this.$store.state.presentation.id}`)
    },

    handleClickPresentAnyway(type) {
      if (type === modalTypes.noCorrectAnswer) {
        if (this.$store.state.presentation.notRemindCorrectAnswer) {
          this.updatePresentationByType('notRemindCorrectAnswer')
        }
        this.isShowingModalQuizNoCorrectAnswer = false
        if (this._isAudiencePacing()) return
      }
      if (type === modalTypes.audiencePacing) {
        this.isShowingModalAudiencePacing = false
      }
      this._startPresenting()
    },

    handleShowShareV2() {
      this.$store.state.presentation.defaultTabShare = 'addEditor'
      this.showShare()
    },

    handleOpenShareToEditPopup() {
      if (this.isGuestUser) {
        // On demo mode, open Sign up page
        this.$router.push({
          name: 'Register',
          query: {
            source: 'demo',
            medium: 'demo',
            campaign: 'demo',
            content: 'share-button',
          },
        })
      } else {
        this.isShareToEditDialogShowing = true
      }

      const teamId = this.$store.state.workingMode === constants.workspace.PERSONAL ?
        null : (
          this.currentAccount.id
        )
      const presentationId = this.$store.state.presentation.id
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
        'Header > Open Invite to edit Popup',
        `Presentation id: ${this.$store.state.presentation.id}`,
        '', {
          teamId,
          presentationId,
        })
    },

    _handleOpenBackstageWindow(source) {
      this.clickedOnPresentWithBackstage = false
      if (this.canUseRemoteControl) {
        this._openRemoteControl()
      } else {
        this._openLegacyBackStage()
      }
      if (source === 'from-context-menu') return
      this._trackingBackstage()
    },

    _openRemoteControl() {
      // Open a smaller window slightly offset from the main window (240px narrower, 180px shorter)
      window.open(this.remoteLink, `Backstage_${this.presentation.id}`,
        `width=${window.outerWidth - WINDOW_WIDTH_OFFSET},height=${window.outerHeight - WINDOW_HEIGHT_OFFSET}`)
    },

    _openLegacyBackStage() {
      if (!this.hasBackstageWindow()) {
        // Open a smaller window slightly offset from the main window (240px narrower, 180px shorter)
        this.backStageWindow = window.open(`/presentation/${this.presentation.id}/backstage`,
          `Backstage_${this.presentation.id}`, `width=${window.outerWidth - WINDOW_WIDTH_OFFSET},height=${window.outerHeight - WINDOW_HEIGHT_OFFSET}`)
        localStorage.setItem(`Backstage_${this.presentation.id}`, JSON.stringify(true))
      } else {
        this.backStageWindow.focus()
      }
    },

    closeBackstageWindow() {
      if (localStorage) {
        localStorage.removeItem(`Backstage_${this.presentation.id}`)
      }

      if (this.backStageWindow) {
        this.backStageWindow.close()
        this.backStageWindow = null
      }
      if (this.isBackstage) {
        window.close()
      }
    },

    _trackingBackstage() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Header > Presenting menu > Backstage',
        this.presentation.id,
      )
    },
    onHideShareToEditModal({ toBeInvitedMembers }) {
      this.isShareToEditDialogShowing = false
      this.checkToShowInviteTeamModal(toBeInvitedMembers)
    },
    checkToShowInviteTeamModal(toBeInvitedMembers) {
      if (
        toBeInvitedMembers && toBeInvitedMembers.length >= 1 &&
        localStorage.getItem(`dont-show-team-invite-modal-again-${this.presentation.id}`) !== 'true' &&
        (!this.hasTeam || (this.hasTeam && this.isTeamOwner))

      ) {
        this.toBeInvitedMembers = toBeInvitedMembers
        setTimeout(() => {
          this.isInviteToTeamModalShowing = true
        }, 500)
      }
    },
    async setTeamData(teamData) {
      if (!teamData) return
      const { code, account } = teamData
      if (code === 'ok') {
        this.showCreateTeamSuccessModal = true

        window.localStorage.setItem(`is-already-has-team-${this.currentUser.id}`, true)
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Invite to Edit > Forming Team modal > Create team success', account.name, '', {
          plan: this.currentUser.plan,
          presentationId: this.presentation.id,
        })
      }
      this.$store.state.currentUser.accountRole = 'owner'
      this.$store.state.currentUser.accountId = account.id
      this.setCurrentAccountAction({
        ...account,
        totalMembers: 1,
      })
      await this.getCurrentUserAction()
    },

    async onHideInviteToTeamModal({ showSuccessModal = false, teamData = null } = {}) {
      this.isInviteToTeamModalShowing = false
      if (teamData) {
        await this.setTeamData(teamData)
      }
      if (showSuccessModal) {
        setTimeout(() => {
          this.isWorkspaceReadyModalShowing = true
        }, 500)
      }
    },

    handlePresentingForPPTAddin() {
      if (!this.isEnableAddinPowerpoint) return
      if (this.powerPointSlideId || this.activePresentationPowerpointId) {
        this._setScreenMode()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";

.editor-header-tab-container {
  @apply bg-base-0 w-full;
  @apply right-0 overflow-y-auto z-20;
  @apply h-full fixed;
  @apply md:absolute md:top-15;
  @media (min-width: 768px) { // md screens
    height: calc(100vh - 3.75rem); // header height is 4rem
    width: $rightSideWidth;
  }
}

.editor-header-content {
  @apply flex justify-around w-full pr-4;
}

.editor-header-left-side {
  @apply flex flex-1 items-center justify-start flex-shrink-0;
  @media (max-width: 768px) {
    &::v-deep {
      .sync-error {
        top: 30px;
        left: 90%;
        .arrow-box::before {
          top: -11px;
          left: 48%;
        }
        .arrow-box::after {
          top: -10px;
          left: 48%;
        }
      }
    }
  }
}

.editor-header-right-side {
  @apply flex items-center justify-end flex-shrink-0 ml-auto;
}

.actions-kebab-menu {
  @apply cursor-pointer inline-block md:hidden -mt-0.25 p-2;
  @apply top-18 absolute right-4;
}
.editor-header-line{
  opacity: 0.5;
  margin: 0 8px;
}

.hide-history-action {
  display: none;
}
</style>
